import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import NeuralWorks from './pages/NeuralWorks';
import NeuralWorksHowItWorks from './pages/NeuralWorksHowItWorks';
import NeuralWorksAccelerators from './pages/NeuralWorksAccelerators';
import NeuralWorksSecurity from './pages/NeuralWorksSecurity';
import WhatWeDo from './pages/WhatWeDo';
import ServicePage from './pages/ServicePage';
import Work from './pages/Work';
import CaseStudy from './pages/CaseStudy';
import Approach from './pages/Approach';
import Industries from './pages/Industries';
import Insights from './pages/Insights';
import InsightPost from './pages/InsightPost';
import About from './pages/About';
import Trust from './pages/Trust';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import Diagnostic from './pages/Diagnostic';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/what-we-do" element={<WhatWeDo />} />
              <Route path="/what-we-do/:slug" element={<ServicePage />} />
              <Route path="/neuralworks" element={<NeuralWorks />} />
              <Route path="/neuralworks/how-it-works" element={<NeuralWorksHowItWorks />} />
              <Route path="/neuralworks/accelerators" element={<NeuralWorksAccelerators />} />
              <Route path="/neuralworks/security-and-governance" element={<NeuralWorksSecurity />} />
              <Route path="/work" element={<Work />} />
              <Route path="/work/:slug" element={<CaseStudy />} />
              <Route path="/approach" element={<Approach />} />
              <Route path="/industries/retail-and-commerce" element={<Industries />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<InsightPost />} />
              <Route path="/about" element={<About />} />
              <Route path="/trust" element={<Trust />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/tools/ai-readiness-diagnostic" element={<Diagnostic />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}
